import DateOnlyCollapse from "./DateOnly.Collapse";

export default DateOnlyCollapse;